import { useState } from "react";
import { motion } from "framer-motion";

const CHECKOUT_URL = "https://payhip.com/order?link=8mes1&pricing_plan=YLBN5OxvzK";
const ease = [0.16, 1, 0.3, 1];

export default function CheckoutButton({ label = "Jetzt für 299€ sichern", testId = "checkout-cta-button" }) {
  const [agreed, setAgreed] = useState(false);
  const [shakeKey, setShakeKey] = useState(0);

  const handleBlockedClick = (e) => {
    if (agreed) return;
    e.preventDefault();
    setShakeKey((k) => k + 1);
  };

  return (
    <div className="flex flex-col items-center gap-4">
      {/* Widerrufsrecht checkbox */}
      <motion.label
        key={shakeKey}
        animate={shakeKey > 0 && !agreed ? { x: [0, -7, 7, -5, 5, -2, 0] } : {}}
        transition={{ duration: 0.45 }}
        className={`flex items-start gap-3 cursor-pointer max-w-sm text-left group rounded-xl p-2 -m-2 transition-colors duration-300 ${
          shakeKey > 0 && !agreed ? "bg-[#C9A84C]/8" : ""
        }`}
        style={shakeKey > 0 && !agreed ? { background: "rgba(201,168,76,0.07)", outline: "1px solid rgba(201,168,76,0.4)" } : {}}
        data-testid="widerruf-label"
      >
        <div className="relative mt-0.5 shrink-0">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            className="sr-only"
            data-testid="widerruf-checkbox"
          />
          <div
            className={`w-4 h-4 rounded border flex items-center justify-center transition-all duration-200 ${
              agreed
                ? "bg-[#C9A84C] border-[#C9A84C]"
                : shakeKey > 0
                  ? "bg-transparent border-[#C9A84C]"
                  : "bg-transparent border-white/20 group-hover:border-[#C9A84C]/50"
            }`}
          >
            {agreed && (
              <svg className="w-2.5 h-2.5 text-[#0A0A0A]" fill="none" viewBox="0 0 12 10">
                <path d="M1 5l3.5 3.5L11 1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </div>
        </div>
        <span className="text-[#86868b] text-xs leading-relaxed">
          Ich stimme zu, dass der Zugang{" "}
          <strong className="text-[#9A9A9A] font-semibold">sofort nach Kaufabschluss</strong>{" "}
          freigeschaltet wird, und verzichte ausdrücklich auf mein{" "}
          <strong className="text-[#9A9A9A] font-semibold">Widerrufsrecht (§ 356 Abs. 5 BGB)</strong>.
        </span>
      </motion.label>

      {/* CTA Button */}
      <motion.a
        href={agreed ? CHECKOUT_URL : undefined}
        target={agreed ? "_blank" : undefined}
        rel="noopener noreferrer"
        onClick={handleBlockedClick}
        data-testid={testId}
        className={`inline-block font-black text-base px-10 py-4 rounded-full transition-all duration-300 select-none ${
          agreed
            ? "bg-[#C9A84C] text-[#0A0A0A] cursor-pointer"
            : "bg-[#C9A84C]/25 text-[#0A0A0A]/40 cursor-pointer"
        }`}
        whileHover={agreed ? { scale: 1.04, boxShadow: "0 0 32px rgba(201,168,76,0.4)" } : {}}
        whileTap={agreed ? { scale: 0.97 } : {}}
        animate={
          agreed
            ? { boxShadow: ["0 0 15px rgba(201,168,76,0.2)", "0 0 28px rgba(201,168,76,0.45)", "0 0 15px rgba(201,168,76,0.2)"] }
            : {}
        }
        transition={agreed ? { duration: 2, repeat: Infinity } : { duration: 0.3, ease }}
      >
        {label}
      </motion.a>

      {!agreed && (
        <p
          className={`text-[11px] transition-colors duration-300 ${
            shakeKey > 0 ? "text-[#C9A84C] font-semibold" : "text-[#86868b]/60"
          }`}
          data-testid="widerruf-hint"
        >
          {shakeKey > 0
            ? "Nur noch 1 Klick: Bestätige kurz die Checkbox oben — dann geht's direkt zum Checkout."
            : "Bitte Zustimmung oben bestätigen, um fortzufahren."}
        </p>
      )}
    </div>
  );
}
